import React from "react";

function TermsOfService() {
  return (
    <div
      style={{
        maxWidth: "900px",
        margin: "0 auto",
        padding: "60px 24px",
        lineHeight: 1.7,
        color: "#09111f",
      }}
    >
      <h1>Terms of Service</h1>
      <p><strong>Effective Date:</strong> April 26, 2026</p>

      <p>
        Welcome to <strong>Enyi</strong>, a product of{" "}
        <strong>JirOAK Labs Ltd</strong>. By using Enyi, you agree
        to these Terms of Service.
      </p>

      <h2>1. Use of Enyi</h2>
      <p>
        Enyi is a bookkeeping and business finance software platform designed
        to help users record income, monitor expenses, upload receipts, and
        receive AI-powered financial guidance.
      </p>

      <p>
        You agree to use Enyi lawfully and not misuse the platform,
        attempt unauthorized access, or interfere with normal operation.
      </p>

      <h2>2. Your Data</h2>
      <p>
        You retain ownership of the financial information, receipts, and
        business records you upload to Enyi.
      </p>

      <p>
        By using Enyi, you grant us permission to process that information
        solely to provide the service.
      </p>

      <h2>3. AI Guidance Disclaimer</h2>
      <p>
        Enyi may provide automated business insights and financial suggestions.
        These are informational only and do not constitute accounting,
        tax, legal, or regulated financial advice.
      </p>

      <p>
        Users remain responsible for business decisions and compliance
        obligations.
      </p>

      <h2>4. Beta Features</h2>
      <p>
        During beta, Enyi supports manual transaction entry and receipt upload.
        Features may change, improve, or be discontinued.
      </p>

      <h2>5. Availability</h2>
      <p>
        We aim to keep Enyi available and secure, but uninterrupted access
        cannot be guaranteed.
      </p>

      <h2>6. Account Security</h2>
      <p>
        You are responsible for keeping your login credentials secure.
      </p>

      <h2>7. Limitation of Liability</h2>
      <p>
        To the maximum extent permitted by law, JirOAK Labs Ltd
        is not liable for indirect losses, lost profits, business interruption,
        or decisions made based on app-generated guidance.
      </p>

      <h2>8. Changes</h2>
      <p>
        We may update these Terms from time to time. Continued use of Enyi
        means acceptance of updated Terms.
      </p>

      <h2>9. Contact</h2>
      <p>
        Support:{" "}
        <a href="mailto:support@enyi.ai">support@enyi.ai</a>
      </p>
    </div>
  );
}

export default TermsOfService;